import './style.scss'

import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'

const FloatingHeader = ({ fromTop = 0, minWidth = -1, maxWidth = -1, triggerSelector = null, children }) => {
  const [isFloating, setIsFloating] = useState(false)

  const isTriggerAboveViewport = useCallback(
    (offset = 0) => {
      const element = window.document.querySelector(triggerSelector)

      if (!element) {
        return false
      }

      const { bottom } = element.getBoundingClientRect()

      return bottom + offset > 0
    },
    [triggerSelector]
  )

  const handleScrollResize = useCallback(() => {
    if (typeof document === 'undefined') {
      return
    }

    if (triggerSelector) {
      if (isTriggerAboveViewport() === isFloating) {
        setIsFloating(!isFloating)
      }
    } else {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const innerWidth = window.innerWidth
      const inWidthRange = (minWidth === -1 || innerWidth >= minWidth) && (maxWidth === -1 || innerWidth <= maxWidth)

      if (inWidthRange && scrollTop > fromTop && !isFloating) {
        setIsFloating(true)
      } else if ((!inWidthRange || scrollTop <= fromTop) && isFloating) {
        setIsFloating(false)
      }
    }
  }, [fromTop, isFloating, isTriggerAboveViewport, maxWidth, minWidth, triggerSelector])

  useEffect(() => {
    window.addEventListener('scroll', handleScrollResize)
    window.addEventListener('resize', handleScrollResize)
    handleScrollResize()

    return () => {
      window.removeEventListener('scroll', handleScrollResize)
      window.removeEventListener('resize', handleScrollResize)
    }
  }, [handleScrollResize])

  return (
    <div>
      <div className={isFloating ? 'float' : 'hide'}>{isFloating ? children : null}</div>
    </div>
  )
}

FloatingHeader.propTypes = {
  fromTop: PropTypes.number,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
  triggerSelector: PropTypes.string,
  children: PropTypes.node
}

export default FloatingHeader
